"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxPlotChart = void 0;
/*
 * © 2026 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
var BoxPlotChart_1 = require("./BoxPlotChart");
Object.defineProperty(exports, "BoxPlotChart", { enumerable: true, get: function () { return BoxPlotChart_1.BoxPlotChart; } });
//# sourceMappingURL=index.js.map